<template>
	<div>
		<v-layout
			wrap
			align-center
			text-xs-center
			primary
			white--text
			class="table-scroll-header"
		>
			<v-flex xs1 v-if="selectable">
				<input
					:checked="allChecked"
					class="input-checkbox"
					type="checkbox"
					:value="allChecked"
					@change="$emit('selected-all', $event.target.checked)"
				/>
			</v-flex>
			<slot name="header"></slot>
		</v-layout>
		<v-layout
			class="table-scroll-body"
			style="max-height: 77vh;"
			align-content-start
			align-center
			text-xs-center
			white
			wrap
		>
			<template v-for="item in rows">
				<tree-item
					:key="item.id"
					:item="item"
					@add-account="$emit('add-account', $event)"
					@delete-account="$emit('delete-account', $event)"
					@edit-account="$emit('edit-account', $event)"
					@row-expanded="$emit('row-expanded', $event)"
				></tree-item>
			</template>
		</v-layout>
		<v-layout justify-end v-if="pagination">
			<v-pagination
				:length="lastPage"
				:total-visible="totalVisible"
				:value="page"
				@input="$emit('change-page', $event)"
			></v-pagination>
		</v-layout>
	</div>
</template>

<script>
	import treeItem from '@/components/accounting-accounts/tree-item';

	function validClass({ amount }) {
		return amount < 0;
	}

	export default {
		name: 'accounting-account-table',
		components: {
			treeItem,
		},
		methods: {
			validClass,
		},
		props: {
			allChecked: {
				default: false,
				type: Boolean,
			},
			btnAdd: {
				default: true,
				type: Boolean,
			},
			btnAddDisabled: {
				default: true,
				type: Boolean,
			},
			btnAddText: String,
			btnFilter: {
				default: true,
				type: Boolean,
			},
			disabledProp: String,
			groupProp: {
				default: 'accounts',
				type: String,
			},
			heading: {
				default: false,
				type: Boolean,
			},
			lastPage: Number,
			page: Number,
			pagination: {
				default: false,
				type: Boolean,
			},
			rows: {
				default: () => [],
				type: Array,
			},
			search: String,
			selectable: {
				default: false,
				type: Boolean,
			},
			selectableProp: String,
			tableHeight: {
				default: '600px',
				type: String,
			},
			totalVisible: {
				default: 5,
				type: Number,
			},
			validateClass: String,
		},
	};
</script>

<style lang="scss" scoped>
	.table-scroll-body {
		border: 1px solid map-get($colors, blue-grey) !important;
		overflow: auto;
	}

	.table-scroll-header {
		font-family: map-get($fonts, open-semibold);
		font-size: size(small13);
		height: 36px;

		&.table-scroll-heading {
			height: 29px;
		}

		.header-table-text {
			color: map-get($colors, black);
			font-family: map-get($fonts, AvenirDemi);
			font-size: 12px;
		}
	}

	.table-scroll-row {
		color: map-get($colors, paginationText);
		font-family: map-get($fonts, open-regular);
		font-size: map-get($sizes, small13);

		.table-scroll-col {
			align-items: center;
			display: flex;
			height: 30px;
			justify-content: center;
		}

		&:nth-child(2n):not(.tooltip) {
			background-color: map-get($colors, background-table);
		}

		:nth-child(2n):not(.tooltip):not(:last-child) {
			border-left: 1px solid map-get($colors, blue-grey);
			border-right: 1px solid map-get($colors, blue-grey);
		}

		:nth-child(2n):not(.tooltip):last-child {
			border-left: 1px solid map-get($colors, blue-grey);
		}
	}

	.input-checkbox {
		border: 1px solid map-get($colors, grey-border);
		border-radius: 1px;
		height: 12px;
		width: 12px;
	}

	.search-input {
		background-color: rgba(0, 0, 0, .2);
		border-radius: 3px;
		box-shadow: inset 0 1px 1px 0 rgba(0, 0, 0, .2);
		display: inline-flex;
		height: 23px;
		max-width: 153px;
		vertical-align: middle;

		input {
			color: map-get($colors, white);
			font-size: 14px;
			outline: none;
			padding: 0 5px;
			width: calc(100% - 25px);
		}

		.icon {
			align-self: center;
			color: map-get($colors, white);
			font-size: map-get($sizes, medium20);
			transform: rotate(90deg);
		}
	}

	.table-scroll-tooltip {
		display: inline-block;
		height: 24px;
	}

	.row-selected {
		background-color: map-get($colors, rowSelected);
		border: 1px solid map-get($colors, borderRowSelected);
	}
</style>


// WEBPACK FOOTER //
// src/components/accounting-accounts/accounting-account-table.vue